import { IManualBookingFormData, IManualBookingFrequency, ManualBookingPeriods } from 'models/shop/manualbooking';
import * as i18n from 'i18next';
import { IAddBookingItemRequest, IFormAddBookingItemRequest } from 'models/bookappointment';
import moment = require('moment');
import { IOrderItem, IShopOrder } from 'models/orders/order';
import { IServicesList } from 'models/shop/shopBookingTemplates';

export function generateFrequencyItems() {
	/**
	 * Use IManualBookingFrequency interface for parsed key values
	 */
	const frequencyItems: { key: string; value: string }[] = [
		{
			key: JSON.stringify({ multiplier: 0, period: ManualBookingPeriods.DoesNotRepeat }),
			value: i18n.t('ManualBookingModal_RecurringEvent_DoesNotRepeat'),
		},
		{
			key: JSON.stringify({ multiplier: 1, period: ManualBookingPeriods.Daily }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Daily'),
		},
		{
			key: JSON.stringify({ multiplier: 2, period: ManualBookingPeriods.Days }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every2Days', { multiplier: 2 }),
		},
		{
			key: JSON.stringify({ multiplier: 3, period: ManualBookingPeriods.Days }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every3-4Days', { multiplier: 3 }),
		},
		{
			key: JSON.stringify({ multiplier: 4, period: ManualBookingPeriods.Days }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every3-4Days', { multiplier: 4 }),
		},
		{
			key: JSON.stringify({ multiplier: 5, period: ManualBookingPeriods.Days }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNDays', { multiplier: 5 }),
		},
		{
			key: JSON.stringify({ multiplier: 6, period: ManualBookingPeriods.Days }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNDays', { multiplier: 6 }),
		},
		{
			key: JSON.stringify({ multiplier: 7, period: ManualBookingPeriods.Days }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNDays', { multiplier: 7 }),
		},
		{
			key: JSON.stringify({ multiplier: 1, period: ManualBookingPeriods.Weekly }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Weekly'),
		},
		{
			key: JSON.stringify({ multiplier: 2, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every2Weeks', { multiplier: 2 }),
		},
		{
			key: JSON.stringify({ multiplier: 3, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every3-4Weeks', { multiplier: 3 }),
		},
		{
			key: JSON.stringify({ multiplier: 4, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every3-4Weeks', { multiplier: 4 }),
		},
		{
			key: JSON.stringify({ multiplier: 5, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNWeeks', { multiplier: 5 }),
		},
		{
			key: JSON.stringify({ multiplier: 6, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNWeeks', { multiplier: 6 }),
		},
		{
			key: JSON.stringify({ multiplier: 7, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNWeeks', { multiplier: 7 }),
		},
		{
			key: JSON.stringify({ multiplier: 8, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNWeeks', { multiplier: 8 }),
		},
		{
			key: JSON.stringify({ multiplier: 9, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNWeeks', { multiplier: 9 }),
		},
		{
			key: JSON.stringify({ multiplier: 10, period: ManualBookingPeriods.Weeks }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNWeeks', { multiplier: 10 }),
		},
		{
			key: JSON.stringify({ multiplier: 1, period: ManualBookingPeriods.Monthly }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Monthly'),
		},
		{
			key: JSON.stringify({ multiplier: 2, period: ManualBookingPeriods.Months }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every2Months', { multiplier: 2 }),
		},
		{
			key: JSON.stringify({ multiplier: 3, period: ManualBookingPeriods.Months }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNMonths', { multiplier: 3 }),
		},
		{
			key: JSON.stringify({ multiplier: 4, period: ManualBookingPeriods.Months }),
			value: i18n.t('ManualBookingModal_RecurringEvent_EveryNMonths', { multiplier: 4 }),
		},
		{
			key: JSON.stringify({ multiplier: 5, period: ManualBookingPeriods.Months }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every5-6Months', { multiplier: 5 }),
		},
		{
			key: JSON.stringify({ multiplier: 6, period: ManualBookingPeriods.Months }),
			value: i18n.t('ManualBookingModal_RecurringEvent_Every5-6Months', { multiplier: 6 }),
		},
	];

	return frequencyItems;
}

export function generateEndItems() {
	const endItemsArray: { key: number; value: string }[] = [];

	endItemsArray.push({ key: 1, value: i18n.t('ManualBookingModal_RecurringEvent_SpecificDate') });

	for (let i = 2; i < 16; i = i + 1) {
		endItemsArray.push({ key: i, value: i18n.t('ManualBookingModal_RecurringEvent_EndsAtTimes', { multiplier: i }) });
	}

	endItemsArray.push({ key: 20, value: i18n.t('ManualBookingModal_RecurringEvent_EndsAtTimes', { multiplier: 20 }) });
	endItemsArray.push({ key: 25, value: i18n.t('ManualBookingModal_RecurringEvent_EndsAtTimes', { multiplier: 25 }) });
	endItemsArray.push({ key: 30, value: i18n.t('ManualBookingModal_RecurringEvent_EndsAtTimes', { multiplier: 30 }) });

	return endItemsArray;
}

export function generateNewBookingItemTimes(
	bookingItems: IAddBookingItemRequest[],
	newTime: moment.Moment,
	oldTime: moment.Moment,
) {
	const newBookingItems: IAddBookingItemRequest[] = JSON.parse(JSON.stringify(bookingItems));
	const newTimeUnix = newTime.clone().unix();
	const oldTimeUnix = oldTime.clone().unix();
	const diff = newTimeUnix - oldTimeUnix;

	newBookingItems.forEach((bi, idx) => {
		if (idx === 0) {
			bi.schedule = newTime.toISOString();

			if (bi?.childrenAddBookingItemRequest?.length) {
				const bundleSchedule = moment(bi.schedule).clone();
				let prevDuration = null;

				bi.childrenAddBookingItemRequest.forEach((cbir, cIdx) => {
					if (cIdx === 0) {
						cbir.schedule = bundleSchedule.toISOString();
					} else {
						cbir.schedule = bundleSchedule.add(prevDuration, 'seconds').toISOString();
					}
					prevDuration = cbir.duration;
				});
			}
		} else {
			bi.schedule = moment(bi.schedule).add(diff, 'seconds').toISOString();

			if (bi?.childrenAddBookingItemRequest?.length) {
				const bundleSchedule = moment(bi.schedule).clone();
				let prevDuration = null;

				bi.childrenAddBookingItemRequest.forEach((cbir, cIdx) => {
					if (cIdx === 0) {
						cbir.schedule = bundleSchedule.toISOString();
					} else {
						cbir.schedule = bundleSchedule.add(prevDuration, 'seconds').toISOString();
					}
					prevDuration = cbir.duration;
				});
			}
		}
	});

	return newBookingItems;
}

export const minBookingItemSchedule = (
	existingBookingItems: IAddBookingItemRequest[],
): { minSchedule: moment.Moment; minItem: IAddBookingItemRequest } => {
	return existingBookingItems.reduce(
		(prev: { minSchedule: moment.Moment; minItem: IAddBookingItemRequest }, current) => {
			let currDate: moment.Moment;
			if (current.childrenAddBookingItemRequest?.length) {
				currDate = minBookingItemSchedule(current.childrenAddBookingItemRequest).minSchedule;
			} else if (!current.schedule) {
				// this should not happen, but just in case
				return prev;
			} else {
				currDate = moment(current.schedule);
			}

			if (!prev || currDate.isBefore(prev.minSchedule)) {
				return { minSchedule: currDate, minItem: current };
			}

			return prev;
		},
		undefined,
	);
};

export const getTimeUnit = (frequencyObj: IManualBookingFrequency): moment.unitOfTime.DurationConstructor => {
	if (!frequencyObj) {
		return null;
	}

	let timeUnit = null;

	switch (frequencyObj.period) {
		case ManualBookingPeriods.Daily:
			timeUnit = 'day';
			break;
		case ManualBookingPeriods.Days:
			timeUnit = 'days';
			break;
		case ManualBookingPeriods.Weekly:
			timeUnit = 'week';
			break;
		case ManualBookingPeriods.Weeks:
			timeUnit = 'weeks';
			break;
		case ManualBookingPeriods.Monthly:
			timeUnit = 'month';
			break;
		case ManualBookingPeriods.Months:
			timeUnit = 'months';
			break;
		case ManualBookingPeriods.DoesNotRepeat:
			timeUnit = null;
			break;
		default:
			timeUnit = null;
			break;
	}

	return timeUnit;
};

export const generateRecurringBookingItems = (
	currentFormValues: IManualBookingFormData,
): IFormAddBookingItemRequest[] => {
	const currentBookingItems: IFormAddBookingItemRequest[] = (
		currentFormValues?.bookingItems?.length ? JSON.parse(JSON.stringify(currentFormValues?.bookingItems)) : []
	).filter((x) => !x?.deleted);

	// if not recurring event then return current bookingItems
	/* 
		edit mode: 
			- if productId add self to ignoredBookings
			- if recurring event and drag and drop (updateOnlySelectedItem = true) then return only the current items
	*/
	if (
		!currentBookingItems?.length ||
		!currentFormValues?.frequency ||
		!currentFormValues?.endsAt ||
		currentFormValues?.updateOnlySelectedItem
	) {
		currentBookingItems?.forEach((cbi) => {
			cbi.ignoredBookings = cbi?.productId ? [cbi.productId] : undefined;
		});
		return currentBookingItems;
	}

	const { frequency, endsAt } = currentFormValues;
	const recurringBookingItems: IFormAddBookingItemRequest[] = JSON.parse(JSON.stringify(currentBookingItems));

	// edit mode: add self to ignored bookings if product id or match with existing order item schedule
	if (currentFormValues?.isEditModeEnabled) {
		recurringBookingItems.forEach((rbi) => {
			if (rbi?.productId) {
				rbi.ignoredBookings = [rbi.productId];
			} else if (currentFormValues?.upcomingRecurringBookingItems?.length) {
				const matchingTimeItem = currentFormValues.upcomingRecurringBookingItems.find((urbi) =>
					moment(urbi.schedule).isSame(rbi.schedule),
				);
				if (matchingTimeItem) {
					rbi.ignoredBookings = [matchingTimeItem.productId];
				} else {
					rbi.ignoredBookings = undefined;
				}
			}
		});
	}

	const frequencyObj: IManualBookingFrequency = JSON.parse(frequency);
	const timeUnit: moment.unitOfTime.DurationConstructor = getTimeUnit(frequencyObj);

	if (timeUnit) {
		// when user chooses "Specific date"
		const endDate = currentFormValues?.endsAtDate && moment(currentFormValues.endsAtDate);
		currentBookingItems.forEach((cbi) => {
			const newSchedule = moment(cbi.schedule).add(frequencyObj.multiplier, timeUnit);

			// End at date or after (endsAt-1) repetitions
			for (let i = 1; currentFormValues?.endsAtDate ? endDate.isAfter(newSchedule) : i < endsAt; i++) {
				// edit mode: add matched productId to ignoreBookings if same schedule
				if (currentFormValues?.upcomingRecurringBookingItems?.length) {
					const matchingTimeItem = currentFormValues.upcomingRecurringBookingItems.find((urbi) =>
						moment(urbi.schedule).isSame(newSchedule),
					);

					if (matchingTimeItem) {
						cbi.ignoredBookings = [matchingTimeItem.productId];
					} else {
						cbi.ignoredBookings = undefined;
					}
				}

				// clean product id as it is from the form booking item
				if (cbi?.productId) {
					cbi.productId = undefined;
				}
				let cbiChildren = cbi.childrenAddBookingItemRequest;
				if (cbiChildren) {
					cbiChildren = cbiChildren.map((child) => ({
						...child,
						schedule: moment(child.schedule)
							.add(frequencyObj.multiplier * i, timeUnit)
							.toDate(),
					}));
				}

				recurringBookingItems.push({
					...cbi,
					childrenAddBookingItemRequest: cbiChildren,
					schedule: newSchedule.toISOString(),
				});
				newSchedule.add(frequencyObj.multiplier, timeUnit);
			}
		});
	}

	return recurringBookingItems;
};

export const generateSingleItem = (
	soi: IOrderItem,
	bookingTemplates: IServicesList[],
	getBookingTemplatesById: (
		bookingTemplateId: string,
		loadResources: boolean,
		loadChldrenBookingTemplates: boolean,
	) => Promise<any>,
): Promise<any> => {
	return new Promise((resolve) => {
		const bookingTemplate = bookingTemplates.find((bt) => bt.sku === soi.productSKU);
		// const calculatedDiscountPrice = bookingTemplate
		// 	? parseFloat((bookingTemplate.originalPrice - soi.price).toFixed(2))
		// 	: 0;
		let itemToReturn = undefined;

		if (bookingTemplate && bookingTemplate?.customData && JSON.parse(bookingTemplate?.customData).isBundle === true) {
			const childrenAddBookingItemRequest = [];
			const bookedOrderItemData = [...soi.bookedOrderItemDatas];

			// Sort by start times so the order is the same as the bundle's booking template children
			const sortedBookedOrderItemData = bookedOrderItemData.sort((a, b) => {
				if (moment(a.startTime).isBefore(b.startTime)) {
					return -1;
				} else if (moment(a.startTime).isAfter(b.startTime)) {
					return 1;
				} else {
					return 0;
				}
			});

			getBookingTemplatesById(bookingTemplate.id, true, true)
				.then((bRes) => {
					const bundleBookingTemplate: IServicesList = bRes.payload.services.find((bt) => bt.id === bookingTemplate.id);

					// generate bundle's children order item data
					bundleBookingTemplate?.childrenBookingTemplates?.map((cbt, cbtIdx) => {
						childrenAddBookingItemRequest.push({
							bookingTemplateId: cbt.id,
							duration: moment(sortedBookedOrderItemData[cbtIdx].endTime).diff(
								moment(sortedBookedOrderItemData[cbtIdx].startTime),
								'seconds',
								true,
							),
							resourceId: sortedBookedOrderItemData[cbtIdx].resourceId,
							schedule: sortedBookedOrderItemData[cbtIdx].startTime,
							id: sortedBookedOrderItemData[cbtIdx]?.id,
						});
					});

					// generate bundle order item data
					itemToReturn = {
						productId: soi?.productId,
						bookingTemplateId: bookingTemplate?.id,
						schedule: soi?.productSchedule,
						resourceId: soi?.bookedOrderItemDatas?.[0]?.resourceId,
						duration: soi?.productDuration,
						childrenAddBookingItemRequest,
						// discountPrice: calculatedDiscountPrice == 0 ? undefined : calculatedDiscountPrice.toString(),
						originalPrice: soi.price,
						id: soi?.id,
					};

					if (itemToReturn) {
						resolve(itemToReturn);
					}
				})
				.catch((err) => Promise.reject(err));
		} else {
			// generate service order item data
			itemToReturn = {
				productId: soi?.productId,
				bookingTemplateId: bookingTemplate?.id,
				schedule: soi?.productSchedule,
				resourceId: soi?.bookedOrderItemDatas?.[0]?.resourceId,
				duration: soi?.productDuration,
				childrenAddBookingItemRequest: [],
				// discountPrice: calculatedDiscountPrice == 0 ? undefined : calculatedDiscountPrice.toString(),
				originalPrice: soi.price,
				id: soi.id,
			};
			resolve(itemToReturn);
		}
	});
};

export const generateFormBookingItems = (
	shopOrder: IShopOrder,
	bookingTemplates: IServicesList[],
	getBookingTemplatesById: (
		bookingTemplateId: string,
		loadResources: boolean,
		loadChildrenBookingTemplates: boolean,
	) => Promise<any>,
): Promise<any> => {
	const promises = [];
	if (!bookingTemplates?.length) {
		return Promise.reject({ message: 'Booking templates not loaded', status: 'error' });
	}

	const memo = {};
	// There are a lot of repeated requests because of recurring items
	const getBookingTemplatesByIdMemo: typeof getBookingTemplatesById = (
		bookingTemplateId,
		loadResources,
		loadChildrenBookingTemplates,
	) => {
		const memoKey = bookingTemplateId + loadResources + loadChildrenBookingTemplates;
		memo[memoKey] =
			memo?.[memoKey] || getBookingTemplatesById(bookingTemplateId, loadResources, loadChildrenBookingTemplates);
		return memo[memoKey];
	};

	shopOrder?.items.forEach((soi) => {
		promises.push(generateSingleItem(soi, bookingTemplates, getBookingTemplatesByIdMemo));
	});

	return Promise.all(promises)
		.then((res: IFormAddBookingItemRequest[]) => {
			// sort items by schedule
			res.sort((a, b) => (moment(a.schedule).isBefore(moment(b.schedule)) ? -1 : 1));
			return Promise.resolve(res);
		})
		.catch((err) => {
			return Promise.reject(err);
		});
};

export const generateFirstRecurringBookingItems = (bookingItems: IFormAddBookingItemRequest[]) => {
	const bookingTemplateIds = new Set();
	const firstItems: IFormAddBookingItemRequest[] = [];

	for (const obj of bookingItems) {
		const bookingTemplateId = obj.bookingTemplateId;

		if (!bookingTemplateIds.has(bookingTemplateId)) {
			firstItems.push(JSON.parse(JSON.stringify(obj)));
			bookingTemplateIds.add(bookingTemplateId);
		} else {
			const existingItem = firstItems.find((item) => item.bookingTemplateId === bookingTemplateId);

			if (moment(obj.schedule).isSameOrBefore(moment(existingItem.schedule))) {
				existingItem.schedule = obj.schedule;
			}
		}
	}

	return firstItems;
};

export const getRecurringFrequency = (bookingItemSchedules: string[]) => {
	const frequency = [];

	const frequencyMappings = [
		{ days: 1, period: ManualBookingPeriods.Daily, multiplier: 1 },
		{ minDays: 2, maxDays: 6, period: ManualBookingPeriods.Days },
		{ days: 7, period: ManualBookingPeriods.Weekly, multiplier: 1 },
		{ days: 14, period: ManualBookingPeriods.Weeks, multiplier: 2 },
		{ days: 21, period: ManualBookingPeriods.Weeks, multiplier: 3 },
		{ days: 28, period: ManualBookingPeriods.Weeks, multiplier: 4 },
		{ minDays: 29, maxDays: 31, period: ManualBookingPeriods.Monthly, multiplier: 1 },
		{ days: 35, period: ManualBookingPeriods.Weeks, multiplier: 5 },
		{ days: 42, period: ManualBookingPeriods.Weeks, multiplier: 6 },
		{ days: 49, period: ManualBookingPeriods.Weeks, multiplier: 7 },
		{ days: 56, period: ManualBookingPeriods.Weeks, multiplier: 8 },
		{ minDays: 59, maxDays: 62, period: ManualBookingPeriods.Months, multiplier: 2 },
		{ days: 63, period: ManualBookingPeriods.Weeks, multiplier: 9 },
		{ days: 70, period: ManualBookingPeriods.Weeks, multiplier: 10 },
		{ minDays: 90, maxDays: 92, period: ManualBookingPeriods.Months, multiplier: 3 },
		{ minDays: 120, maxDays: 123, period: ManualBookingPeriods.Months, multiplier: 4 },
		{ minDays: 150, maxDays: 153, period: ManualBookingPeriods.Months, multiplier: 5 },
		{ minDays: 181, maxDays: 184, period: ManualBookingPeriods.Months, multiplier: 6 },
	];

	for (let i = 1; i < bookingItemSchedules.length; i++) {
		const currentSchedule = bookingItemSchedules[i];
		const previousSchedule = bookingItemSchedules[i - 1];
		const diffInDays = Math.round(moment(currentSchedule).diff(moment(previousSchedule), 'days'));

		const mapping = frequencyMappings.find(({ days, minDays, maxDays }) => {
			if (days) {
				return diffInDays === days;
			} else if (minDays && maxDays) {
				return diffInDays >= minDays && diffInDays <= maxDays;
			}
			return false;
		});

		if (mapping) {
			frequency.push({ multiplier: mapping.multiplier || diffInDays, period: mapping.period });
		}
	}

	return JSON.stringify(frequency[0]);
};

export const getPriceFromBookingItem = (bookingItem: IFormAddBookingItemRequest, bookingTemplate: IServicesList) =>
	bookingItem?.discountPrice != undefined
		? parseFloat(bookingItem.discountPrice.toFixed(2))
		: bookingItem?.originalPrice != undefined
		  ? bookingItem.originalPrice
		  : bookingTemplate.price;
